import {Component, Input, OnInit} from '@angular/core';
import {NationalityModel} from '../../../../shared/dto/nationality.model';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NationalityService} from '../../../../shared/service/nationality.service';
import {ActionMode} from '../../../../shared/enums/action-mode.enum';
import swal from "sweetalert2";
import {NationalityPopupComponent} from '../nationality-popup/nationality-popup.component';
import {NationalityComponent} from '../nationality.component';

@Component({
  selector: 'app-nationality-search-table',
  templateUrl: './nationality-search-table.component.html',
  styleUrls: ['./nationality-search-table.component.scss']
})
export class NationalitySearchTableComponent implements OnInit {
  @Input() items: NationalityModel[];
  @Input() index: number;
  @Input() page: number=1;
  @Input() itemsPerPage: number=5;
  private nationalityDTO: NationalityModel[] = [];

  constructor( public modalService: NgbModal,
               private nationalityMgt: NationalityComponent,
               private nationalityService: NationalityService) { }

  ngOnInit() {
    this.loadNationalities();
  }

  loadNationalities() {
    this.nationalityService.getAllNationalities().subscribe(
      (data: NationalityModel[]) => {
        this.nationalityDTO = data;
      }
    );
  }

  onClickUpdate(Item){
    const modalRef = this.modalService.open(NationalityPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "Update Nationality Details";
    modalRef.componentInstance.code =  Item.nationalityCode;
    modalRef.componentInstance.description = Item.nationalityDescription;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.designationMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.UPDATE;
    modalRef.result.then(
      (data: string) => {
        if (data == "Saved") {
          this.nationalityMgt.onLoadGetData();
        }
      },
      () => { }
    );
  }

  onDelete(Item) {
    swal.fire({
      title: "Are you sure, you want to delete?",
      text: "",
      showCancelButton: true,

      confirmButtonText: "Yes"
    }).then(
      (result) => {
        if(result.value) {
          this.nationalityService.deleteNationalityDetails(Item.nationalityCode).subscribe(
            (res: boolean) => {
              if (res === true) {
                swal.fire("Success", "Details Deleted successfully", "success");
                this.items.splice(Item, 1);
                this.loadNationalities();
              } else if (res === false) {
                swal.fire("Sorry!", "Details can't be deleted...!", "error");
              }
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
              this.loadNationalities();
            }
          );
        }
      }, reason => {
      }
    );
  }

  onClickView(Item){
    const modalRef = this.modalService.open(NationalityPopupComponent, {
      windowClass: "xlModal"
    });
    modalRef.componentInstance.name = "View Nationality Details";
    modalRef.componentInstance.code =  Item.nationalityCode;
    modalRef.componentInstance.description = Item.nationalityDescription;
    modalRef.componentInstance.selectedState = Item.status;
    modalRef.componentInstance.designationMgtCopy_ = Item;
    modalRef.componentInstance.selectedMode = ActionMode.VIEW;
  }
}
